import { Icon } from '@eventbrite/eds-icon';
import { Star } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

export const RatingEmptyState = () => {
    return (
        <div className="empty-state--container" data-testid="empty-state">
            <Icon
                type={<Star />}
                title="Empty star"
                size="xsmall"
                color="ui-orange"
            />
            <p className="eds-text-bs eds-text-color--ui-600 eds-l-mar-left-1">
                {gettext('Not enough ratings')}
            </p>
        </div>
    );
};
